import React, { Component } from 'react';
import { Link } from "react-router-dom";
import TerritorySelect from '../../common/TerritorySelect';
import Pagination from '../../common/Pagination';
import { HttpRequestService } from '../../services/HttpRequestService';
import { UtilsService } from '../../services/UtilsService';
import Accordion from '../../common/Accordion';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

class TargetList extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            customerNumber: '',
            customer: '',
            territoryId: -1,
            address: '',
            lastCallNotesBeginDate: null,
            lastCallNotesEndDate: null,
            keyword: '',
            accounts: [],
            pageCount: 0,
            pageIndex: 0,
            sortBy: '',
            sortDirection: 'ASC',
        };
        this.paramsKey = 'params.target-list';
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);
        this.http = new HttpRequestService();
        this.pageSize = 50;

        this.handleCustomerNumberChange = this.handleCustomerNumberChange.bind(this);
        this.handleCustomerChange = this.handleCustomerChange.bind(this);
        this.handleTerritoryChange = this.handleTerritoryChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleLastCallNotesBeginDateChange = this.handleLastCallNotesBeginDateChange.bind(this);
        this.handleLastCallNotesEndDateChange = this.handleLastCallNotesEndDateChange.bind(this);
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.getAccounts = this.getAccounts.bind(this);
    }

    componentDidMount() {
        this.getAccounts(this.state.pageIndex);
    }

    handleCustomerNumberChange(e) {
        this.setState({ customerNumber: e.target.value });
    }

    handleCustomerChange(e) {
        this.setState({ customer: e.target.value });
    }

    handleTerritoryChange(territoryId) {
        this.setState({ territoryId: territoryId });
    }

    handleAddressChange(e) {
        this.setState({ address: e.target.value });
    }

    handleLastCallNotesBeginDateChange(date) {
        this.setState({ lastCallNotesBeginDate: date });
    }

    handleLastCallNotesEndDateChange(date) {
        this.setState({ lastCallNotesEndDate: date });
    }

    handleKeywordChange(e) {
        this.setState({ keyword: e.target.value });
    }

    handlePageChange(page) {
        this.getAccounts(page);
    }

    handleSort(field) {
        var sortDirection = 'ASC';
        if (this.state.sortBy === field) {
            sortDirection = this.state.sortDirection === 'ASC' ? 'DESC' : 'ASC';
        }
        this.setState({ sortBy: field, sortDirection: sortDirection }, () => {
            this.getAccounts(this.state.pageIndex);
        });
    }

    getAccounts(page, e) {
        if (!!e) {
            e.preventDefault();
        }
        this.setState({ pageIndex: page });
        var params = {
            customerNumber: this.state.customerNumber,
            customer: this.state.customer,
            territoryId: this.state.territoryId,
            address: this.state.address,
            lastCallNotesBeginDate: this.state.lastCallNotesBeginDate != null ? moment(this.state.lastCallNotesBeginDate).format('L') : '',
            lastCallNotesEndDate: this.state.lastCallNotesEndDate != null ? moment(this.state.lastCallNotesEndDate).format('L') : '',
            keyword: this.state.keyword,
            sortBy: this.state.sortBy,
            sortDirection: this.state.sortDirection,
            pageSize: this.pageSize,
            pageIndex: page,
        };

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Crm/GetTargetList', params).then(data => {
            this.setState({ accounts: data.data, pageCount: parseInt(Math.ceil(data.count / this.pageSize)) });
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Target List</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Accordion title="Advanced Filters" icon="flaticon-search-1" id="advanced-filters">
                            <form onSubmit={(e) => this.getAccounts(0, e)}>
                                <div className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Customer #</label>
                                        <input type="text" className="form-control" value={this.state.customerNumber} onChange={this.handleCustomerNumberChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Customer</label>
                                        <input type="text" className="form-control" value={this.state.customer} onChange={this.handleCustomerChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Territory</label>
                                        <TerritorySelect value={this.state.territoryId} onChange={this.handleTerritoryChange}></TerritorySelect>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Address</label>
                                        <input type="text" className="form-control" value={this.state.address} onChange={this.handleAddressChange} />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Last Call Notes Date (From)</label>
                                        <DatePicker className="form-control" selected={this.state.lastCallNotesBeginDate} onChange={this.handleLastCallNotesBeginDateChange} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>Last Call Notes Date (To)</label>
                                        <DatePicker className="form-control" selected={this.state.lastCallNotesEndDate} onChange={this.handleLastCallNotesEndDateChange} />
                                    </div>
                                </div>
                                <div className="form-row justify-content-end">
                                    <button type="submit" className="btn btn-primary">Search</button>
                                </div>
                            </form>
                        </Accordion>
                        <div className="card">
                            <div className="card-body">
                                <div className="form-row mb-3">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <div className="input-group">
                                                <input type="text" className="form-control col-md-9" placeholder="Search..." value={this.state.keyword} onChange={this.handleKeywordChange} />
                                                <div className="input-group-append col-md-3">
                                                    <button className="btn btn-primary" type="button" onClick={(e) => this.getAccounts(0, e)}>
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <table className="table table-striped mt-1">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="sortable" onClick={() => this.handleSort("AccountNumber")}>
                                                    Customer #
                                                </th>
                                                <th scope="col" className="sortable" onClick={() => this.handleSort("acc.Name")}>
                                                    Customer
                                                </th>
                                                <th scope="col" className="sortable" onClick={() => this.handleSort("territoryOption.Name")}>
                                                    Territory
                                                </th>
                                                <th scope="col" className="sortable" onClick={() => this.handleSort("Address1")}>
                                                    Address Line 1
                                                </th>
                                                <th scope="col" className="sortable" onClick={() => this.handleSort("CallbackDateTime")}>
                                                    Last Call Notes Date
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.accounts.map((account, index) =>
                                                <tr key={index}>
                                                    <td><Link to={"/customer/" + account.customerId}>{account.customerNumber}</Link></td>
                                                    <td><Link to={"/customer/" + account.customerId}>{account.customer}</Link></td>
                                                    <td>{account.territory}</td>
                                                    <td>{account.addressLine1}</td>
                                                    <td>{account.lastCallNotesDate}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.accounts.length > 0 &&
                                            <Pagination pageIndex={this.state.pageIndex} pageCount={this.state.pageCount} onPageChanged={this.handlePageChange}></Pagination>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TargetList;
